import React, { Component, Suspense, Fragment, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import AuthenticationHOC from '../hoc/AuthenticationHOC';
import Admin from './Admin';

import Companies from '../pages/company/Companies'
import SignUp from '../pages/authentication/SignUp'
import Landing from '../pages/authentication/Landing'

import ReactGa from 'react-ga'

const Auth = React.lazy(() => import('./Auth'));
const Page404 = React.lazy(() => import('../pages/errors/404'));
const Page403 = React.lazy(() => import('../pages/errors/403'));
const Maintenance = React.lazy(() => import('../pages/maintenance/SiteDown'));

export default function App() {

  useEffect(() => {
    ReactGa.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS}`)
    // to report page view
    ReactGa.pageview(window.location.pathname + window.location.search)

  }, [])

  return (
    <Fragment>
      <ToastContainer draggable={false} />
      <Suspense fallback={ <Spinner color="default" /> }>
        <Switch>
          {/* Authenticated routes */}
          <Route path="/" exact component={(Landing)} />
          <Route path="/errors/403" component={Page403} />
          <Route path="/errors/404" component={Page404} />
          <Route path="/" render={() => {
            return <Redirect to="/" />
          }} />
        </Switch>
      </Suspense>
    </Fragment>
  )

}
